import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'gf-checkbox-list',
  template: require('./gf-checkbox-list.component.html')
})
export class CheckboxListComponent implements OnInit, OnChanges {
  @Input() field: any;
  @Input() fieldElements: any[];

  itemsFilter = "";
  displayElements: any[] = [];

  assignNone(): void {
    this.field.fieldData = [];
  }

  ngOnInit(): void {
    this.applyFilter();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.applyFilter();
  }

  applyFilter() {
    const f = this.itemsFilter ?? '';

    if (! f.length) {
      this.displayElements = this.fieldElements;
    } else {
      const regex = new RegExp(this.itemsFilter, 'i');
      this.displayElements = _.filter(
        this.fieldElements,
        function(elem) {
          return elem.label.match(regex);
        }
      );
    }
  }

  toggleElement(fieldElement: any): void {
    fieldElement.checked = (_.get(fieldElement, 'checked', false) == false);
    this.field.fieldData = _.filter(
      this.fieldElements, 'checked'
    );
  }
}
